import BaseEntity from "./base.entity";
import uuid from "uuid";

export default class Category extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid(),
      category_uuid: null,
      name: ""
    };
  }

  getServiceObject() {
    return {
      uuid: this.uuid,
      category_uuid: this.category_uuid,
      name: this.name
    };
  }

  identifier(defaultIdentifier = "Categoria em branco") {
    return this.name || defaultIdentifier;
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/category.entity.js